import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import PageSeo from "../components/PageSeo";
import "./About.css";

const bikes = [
  { name: "Hero HF Deluxe", price: 55000, mileage: 75, type: "city", category: "commuter" },
  { name: "Bajaj Platina 100", price: 60000, mileage: 80, type: "city", category: "commuter" },
  { name: "TVS Sport", price: 65000, mileage: 70, type: "city", category: "commuter" },
  { name: "Honda Dream Yuga", price: 70000, mileage: 72, type: "city", category: "commuter" },
  { name: "Hero Splendor Plus", price: 75000, mileage: 80, type: "city", category: "commuter" },
  { name: "Suzuki Access 125", price: 85000, mileage: 50, type: "scooter", category: "scooter" },
  { name: "Honda Shine", price: 90000, mileage: 65, type: "city", category: "commuter" },
  { name: "TVS Raider", price: 100000, mileage: 60, type: "city", category: "commuter" },
  { name: "Yamaha FZ-S", price: 125000, mileage: 50, type: "highway", category: "sports" },
  { name: "Hero Xpulse 200", price: 150000, mileage: 40, type: "touring", category: "adventure" },
  { name: "Royal Enfield Classic 350", price: 220000, mileage: 35, type: "touring", category: "cruiser" },
  { name: "Bajaj Dominar 400", price: 230000, mileage: 27, type: "touring", category: "sports" },
  { name: "KTM Adventure 390", price: 350000, mileage: 25, type: "touring", category: "adventure" },
  { name: "BMW G 310 R", price: 320000, mileage: 32, type: "highway", category: "sports" },
  { name: "Ola S1 Pro", price: 130000, mileage: 181, type: "city", category: "electric" },
  { name: "Ather 450X", price: 145000, mileage: 146, type: "city", category: "electric" },
];

export default function BikeRecommendation() {
  const [budget, setBudget] = useState("");
  const [mileage, setMileage] = useState("");
  const [usage, setUsage] = useState("");
  const [category, setCategory] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  const recommend = () => {
    const b = Number(budget);
    const m = Number(mileage);
    if (!b) return;
    const filtered = bikes.filter(
      (bike) =>
        bike.price <= b &&
        (!m || bike.mileage >= m) &&
        (!usage || bike.type === usage) &&
        (!category || bike.category === category)
    );
    setResults(filtered);
  };

  const goToEmi = (bike) => {
    navigate(`/calculator/emi?loan=${bike.price}&bike=${encodeURIComponent(bike.name)}`);
  };

  return (
    <>
      <PageSeo
        title="AI Bike Finder India | MotoHub India"
        description="Find the best bike by budget, mileage, category and usage."
        path="/recommend"
      />

      <div className="aboutx-root">
        <div className="aboutx-wrap">
          <motion.article className="aboutx-panel" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <p className="aboutx-kicker">AI Bike Finder</p>
            <h3>Find your best bike in seconds.</h3>
            <p>Filter by budget, mileage, usage and category to get practical options for Indian riders.</p>

            <div style={{ display: "grid", gap: "10px", marginTop: "16px" }}>
              <input placeholder="Your Budget (Rs)" value={budget} onChange={(e) => setBudget(e.target.value)} />
              <input placeholder="Minimum Mileage (optional)" value={mileage} onChange={(e) => setMileage(e.target.value)} />
              <select value={usage} onChange={(e) => setUsage(e.target.value)}>
                <option value="">Usage Type</option>
                <option value="city">City</option>
                <option value="highway">Highway</option>
                <option value="touring">Touring</option>
              </select>
              <select value={category} onChange={(e) => setCategory(e.target.value)}>
                <option value="">Category</option>
                <option value="commuter">Commuter</option>
                <option value="sports">Sports</option>
                <option value="cruiser">Cruiser</option>
                <option value="adventure">Adventure</option>
                <option value="scooter">Scooter</option>
                <option value="electric">Electric</option>
              </select>
              <button style={primaryBtn} onClick={recommend}>Find Bikes</button>
            </div>
          </motion.article>
        </div>

        <div className="aboutx-wrap">
          <div className="aboutx-grid">
            {results.length === 0 ? (
              <article className="aboutx-panel">
                <p style={{ color: "#a1a1aa" }}>No bikes found yet. Enter filters and click "Find Bikes".</p>
              </article>
            ) : (
              results.map((bike, index) => (
                <motion.article
                  key={`${bike.name}-${index}`}
                  className="aboutx-tilt-card"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.05 }}
                >
                  <h3>{bike.name}</h3>
                  <p>Price: Rs {bike.price.toLocaleString("en-IN")}</p>
                  <p>Mileage: {bike.mileage} km/l</p>
                  <p>Category: {bike.category}</p>
                  <p>Type: {bike.type}</p>
                  <button style={smallBtn} onClick={() => goToEmi(bike)}>View EMI</button>
                </motion.article>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const primaryBtn = {
  padding: "12px",
  borderRadius: "12px",
  border: "none",
  fontWeight: 700,
  color: "#fff",
  cursor: "pointer",
  background: "linear-gradient(120deg, #f59e0b, #ea580c)",
};

const smallBtn = {
  marginTop: "10px",
  padding: "10px 12px",
  background: "linear-gradient(120deg, #f59e0b, #ea580c)",
  border: "none",
  borderRadius: "10px",
  color: "#fff",
  cursor: "pointer",
  fontWeight: 700,
};
